import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 17 25" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="#FFF" d="M3.82 25.005L.675 21.897l9.397-9.397L.675 3.121 3.82-.005 16.325 12.5z" fillRule="evenodd" /></svg>);